import { type IntlShape } from 'react-intl'

import { priceGetFormattedPrice } from '../price'

/**
 * The function reformats price coming from recommendation widgets
 *
 * Recommendation price format:
 * ```
 * ┌─ currency sign (€) or code (CHF)
 * │ ┌─ integer
 * │ │ ┌─ decimal (dot)
 * │ │ │     ┌─ optional unit
 * € 10,36 / st
 * ```
 */
export const recommendationGetFormattedPrice = ({
  intl,
  price,
  unit,
}: {
  intl: IntlShape
  price: string
  unit?: string | null
}): string | undefined => {
  const amount = Number(price)

  let formattedPrice = priceGetFormattedPrice(amount, intl)

  if (unit?.length) {
    formattedPrice += ` / ${unit}`
  }

  return formattedPrice
}
